var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailhelpcenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#346CEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 29.4997V29.5V50.5C57.75 51.3934 57.4262 52.1536 56.769 52.7936C56.1117 53.4337 55.3268 53.7511 54.4003 53.75H54.4H25.6C24.6745 53.75 23.89 53.4326 23.2327 52.7935C22.5756 52.1547 22.2512 51.3946 22.25 50.4998V29.5C22.25 28.6067 22.5742 27.8473 23.2325 27.2084C23.8912 26.5691 24.6759 26.2511 25.6001 26.25H54.4C55.3253 26.25 56.1105 26.5679 56.7691 27.2082C57.4275 27.8484 57.7511 28.6078 57.75 29.4997ZM58 29.5V50.5C58 51.4625 57.6478 52.2867 56.9434 52.9727C56.239 53.6587 55.3912 54.0012 54.4 54H25.6C24.61 54 23.7628 53.6576 23.0584 52.9727C22.354 52.2879 22.0012 51.4637 22 50.5L58 29.5ZM40 41.4575L25.85 32.8594V29.9444L39.8702 38.4636L40 38.5425L40.1298 38.4636L54.5298 29.7136L55.2929 29.25H54.4H25.6H25.35V29.5V33V33.1406V50.5V50.75H25.6H54.4H54.65V50.5V33V32.5556L54.2702 32.7863L40 41.4575Z",
    fill: "white",
    stroke: "#346CEA",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailhelpcenter);
export default __webpack_public_path__ + "static/media/emailhelpcenter.69b23d8ececca3b554d094fbc4f36bf6.svg";
export { ForwardRef as ReactComponent };